import React from "react";
import { db } from "../Config/firebase";
import "./RelatorioRAAPrint.css";
import { doc, getDoc } from "firebase/firestore";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  ReferenceLine,
  ReferenceArea,
  ResponsiveContainer
} from "recharts";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";



export default function RelatorioRAAPrint({ ensaio, leituras, onVoltar, autoPrint = false, onReady }) {
  const [materiais, setMateriais] = React.useState({});
  const [carregado, setCarregado] = React.useState(false);
  const jaImprimiuRef = React.useRef(false);
  useNomeArquivoPdf(
    ensaio?.codigo
      ? `CE-RE-RAA-${ensaio.codigo}/${ensaio.dataMoldagem?.split("-")[0] || ""}`
      : ""
  );

  function material(nome, campo) {
  return materiais?.[nome]?.[campo] || "-";
}
  
  React.useEffect(() => {

      setCarregado(false);
      jaImprimiuRef.current = false;

      async function carregarMateriais() {

          try {

            let agregadoSnap = null;
let cimentoSnap = null;
let adicaoSnap = null;

try {

  [agregadoSnap, cimentoSnap, adicaoSnap] = await Promise.all([
    ensaio?.agregadoId
      ? getDoc(doc(db, "tblListaMateriaisCadastrados", ensaio.agregadoId))
      : null,

    ensaio?.cimentoId
      ? getDoc(doc(db, "tblListaMateriaisCadastrados", ensaio.cimentoId))
      : null,

    ensaio?.adicaoId
      ? getDoc(doc(db, "tblListaMateriaisCadastrados", ensaio.adicaoId))
      : null
  ]);

} catch (error) {
  console.warn("Sem permissão para materiais:", error);
}

            setMateriais({
              agregado: agregadoSnap?.data() || null,
              cimento: cimentoSnap?.data() || null,
              adicao: adicaoSnap?.data() || null
            });

            setCarregado(true);   // 👈 AQUI

          } catch (erro) {
            console.error("Erro ao carregar materiais", erro);
          }
        }

      carregarMateriais();

    }, [ensaio]);

  React.useEffect(() => {
    if (!autoPrint || !carregado || jaImprimiuRef.current) return;

    jaImprimiuRef.current = true;

    const frame = window.requestAnimationFrame(() => {
      window.print();
    });

    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint, carregado]);

  React.useEffect(() => {
    if (carregado) onReady?.();
  }, [carregado, onReady]);



      function formatarDataBR(dataISO) {
        if (!dataISO) return "";

        const [ano, mes, dia] = dataISO.split("-");
        return `${dia}/${mes}/${ano}`;   // 🔥 agora completo
      }

function formatarDataExtenso(dataISO) {
  if (!dataISO) return "-";

  const [ano, mes, dia] = dataISO.split("-");
  const data = new Date(ano, mes - 1, dia);

  return data.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}
function dataHojeISO() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, "0");
  const dia = String(hoje.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
}

function CabecalhoRelatorio({ ensaio, materiais, formatarDataBR }) {
  return (
    <>
    

      {/* ================= BLOCO 2 ================= */}
<div className="linha-separadora"></div>

<table className="bloco2">
  <tbody>
    <tr>
      <td colSpan="7">
        <strong>EMPRESA:</strong> {ensaio?.cliente || "-"}
      </td>
    </tr>

    <tr>
      <td colSpan="7">
        <strong>LOCAL/OBRA:</strong> -
      </td>
    </tr>
  </tbody>
</table>

<div className="linha-separadora"></div>
    </>
  );
}
const dadosBrutos = leituras
  .map((l) => {
    const diff =
      (new Date(l.dataLeitura) - new Date(ensaio.dataMoldagem)) /
      (1000 * 60 * 60 * 24);

    return {
      dia: Math.round(diff),
      expansao: l.expansaoMedia !== null && l.expansaoMedia !== ""
  ? Number(l.expansaoMedia)
  : null
    };
  })
  .filter(d => d.expansao !== null && !isNaN(d.dia));

/* cria estrutura contínua de 1 a 31 */
      const leiturasProcessadas = leituras
  .map((l) => {
    const diff =
      (new Date(l.dataLeitura) - new Date(ensaio.dataMoldagem)) /
      (1000 * 60 * 60 * 24);

    return {
      dia: Math.round(diff),
      expansao: l.expansaoMedia !== null && l.expansaoMedia !== ""
  ? Number(l.expansaoMedia)
  : null,
      dataLeitura: l.dataLeitura
    };
  })


    const ultimaLeitura = [...leiturasProcessadas]
  .filter(l => l.expansao !== null)
  .sort((a, b) => b.dia - a.dia)[0];
const leiturasValidas = leiturasProcessadas.filter(
  l => l.expansao !== null && l.expansao !== ""
);

// 🔥 garante leitura válida no dia ~30
const leituraFinal = leiturasProcessadas[8]; // 🔥 leitura 9 (fixa)

const leituraFinalValida =
  leituraFinal &&
  leituraFinal.expansao !== null &&
  leituraFinal.expansao !== "";
const dataInicio = new Date(ensaio.dataMoldagem);

const ultimaDataLeitura = leiturasProcessadas.length
  ? leiturasProcessadas
      .map(l => new Date(l.dataLeitura))
      .sort((a, b) => b - a)[0]
  : dataInicio;

const diffFinal =
  (ultimaDataLeitura - dataInicio) / (1000 * 60 * 60 * 24);

const ultimoDia = Math.max(1, Math.round(diffFinal));


/* ordena leituras */
const ordenado = [...leiturasProcessadas]
  .sort((a, b) => a.dia - b.dia);

/* função de interpolação linear */
function interpolar(x, x1, y1, x2, y2) {
  return y1 + (x - x1) * ((y2 - y1) / (x2 - x1));
}
const dadosGrafico = ordenado
  .filter(l => l.expansao !== null)
  .map(l => ({
    dia: l.dia,
    expansao: l.expansao
  }));

  const maxExpansao = Math.max(...dadosGrafico.map(d => d.expansao), 0.19);

/* cria margem e arredonda a escala */
const ymaxCalculado = Math.ceil((maxExpansao + 0.05) * 10) / 10;
const ymax = Math.max(0.5, ymaxCalculado);

  const classificacao = leituraFinalValida
  ? classificar(leituraFinal.expansao)
  : "-";
function classificar(valor) {
  if (valor <= 0.19) {
    return "Mitigação Comprovada.";
  } else {
    return "Mitigação Não Comprovada.";
  }
}
function classificarReatividade(exp) {
  if (exp < 0.19) {
    return "Potencialmente inócuo grau R0 (Menor que 0,19).";
  }

  if (exp >= 0.19 && exp <= 0.40) {
    return "Potencialmente inócuo grau R1 (Entre 0,19% e 0,40%).";
  }

  if (exp >= 0.41 && exp <= 0.60) {
    return "Potencialmente inócuo grau R2 (Entre 0,41% e 0,60%).";
  }

  if (exp > 0.60) {
    return "Potencialmente deletério grau R3 (Maior que 0,60%).";
  }

  return "-";
}
function formatarDataFirestore(data) {

  if (!data) return "-";

  if (data?.seconds) {

    const d = new Date(data.seconds * 1000);

    const dia = String(d.getDate()).padStart(2,"0");
    const mes = String(d.getMonth()+1).padStart(2,"0");
    const ano = d.getFullYear();

    return `${dia}/${mes}/${ano}`;

  }

  return data;

}

function gerarRegistro(codigo) {

  if (!codigo || !ensaio?.dataMoldagem) return "-";

  const ano = ensaio.dataMoldagem.split("-")[0];

  return codigo;

}

          const materiaisAmostra = ["agregado","cimento","adicao"]
              .map(tipo => ({
                tipo: material(tipo,"Descricao"),
                codigo: material(tipo,"codigo"),
                data: materiais?.[tipo]?.DataCadastro,
                fornecedor: material(tipo,"Fornecedor"),
                localColeta: material(tipo,"LocalColeta") // ✅ NOVO
              }))
              // REMOVE O FILTER
// .filter(m => m.codigo !== "-");

              const percentualAdicao = Number(ensaio?.percentualAdicao || 0);

const massaAdicao =
  percentualAdicao > 0
    ? (440 / 100) * percentualAdicao
    : 0;

const massaCimento =
  percentualAdicao > 0
    ? 440 - massaAdicao
    : 440;
  return (
  <div className="relatorio-print">

  {/* BOTÕES */}
  {onVoltar && (
  <div className="acoes-print">
    <button onClick={onVoltar} className="btn-voltar">Voltar</button>
    <button onClick={() => window.print()} className="btn-imprimir">Imprimir</button>
  </div>
)}

  <div className="preview-container">

    <div className="pagina">
 
      {/* ================= BLOCO 1 ================= */}
      <table className="tabela bloco1">
        <tbody>
          <tr>
            <td rowSpan="3" style={{ width: 120 }}>
              <LogoRelatorio alt="Logo" className="logo"  />
            </td>

            <td colSpan="5" rowSpan="3" className="titulo">
              SISTEMA DE GESTÃO DA QUALIDADE
              <br />
              RELATÓRIO DE ENSAIO – REATIVIDADE ÁLCALI-AGREGADO
            </td>

            <td className="center" style={{ width: 170 }}>
              RQ 2.2.4-B
            </td>
          </tr>

          <tr>
            <td className="center">REVISÃO 01</td>
          </tr>

          <tr>
            <td className="center">25/02/2026</td>
          </tr>
         
            <tr>
                        <td colSpan="3" style={{ borderRight: "none", textAlign: "left" }}>
                          <strong>DATA:</strong> {formatarDataBR(dataHojeISO())}
                        </td>

                        <td colSpan="4" style={{ borderLeft: "none", textAlign: "right" }}>
                          <strong>CÓDIGO:</strong> CE-RE-RAA-{ensaio.codigo}/{ensaio.dataMoldagem?.split("-")[0]}
                        </td>
                      </tr>
        </tbody>
      </table>

      {/* ================= BLOCO 2 ================= */}
<table className="bloco2">
  <tbody>

    <tr>
      <td colSpan="7">
        <strong>EMPRESA:</strong> {ensaio?.cliente || "-"}
      </td>
    </tr>

    <tr>
      <td colSpan="7">
        <strong>LOCAL/OBRA:</strong> {ensaio?.obra || "-"}
      </td>
    </tr>

  </tbody>
</table>
  

{/* ================= SEÇÃO 1 ================= */}
<div className="titulo-secao">
  1. ENSAIO REALIZADO.
</div>

<div className="secao-texto">
  Reatividade Álcali-Agregado. Parte 5: Determinação da Mitigação da
  Expansão em Barras de Argamassa pelo Método Acelerado.
  Cimento da Obra.
</div>

{/* ================= SEÇÃO 2 ================= */}
<div className="titulo-secao">
  2. OBJETIVO.
</div>       
    

<div className="secao-texto">
  Este relatório tem por finalidade apresentar 
  os resultados dos ensaios realizados em amostra 
  de agregado para concreto, referente ao estudo 
  de materiais enviados ao nosso Laboratório em Luzimangues 
  Distrito de Porto Nacional - TO.
</div>

{/* ================= SEÇÃO 3 ================= */}
<div className="titulo-secao">
  3. METODOLOGIA.
</div>     
    
      <div className="secao-texto">
        NBR 7211/2022 - Agregados para Concreto: Especificação;<br/>
        NBR 15577-1/18 – Agregados: Reatividade Álcali-Agregado.
        Parte 1: Guia para Avaliação da Reatividade Potencial e Medidas
        Preventivas para Uso de Agregados em Concreto;<br/>
        NBR 15577-5/18 – Agregados: Reatividade Álcali-Agregado.
        Parte 5: Determinação da Mitigação da Expansão em Barras de
        Argamassa pelo Método Acelerado.
      </div> 

{/* ================= SEÇÃO 4 - AMOSTRA ================= */}

<div className="titulo-secao">
  4. AMOSTRA.
</div>

<table className="tabela-amostra">
  <tbody>

    <tr>
  <td colSpan="6" className="info-amostra">
    <strong>Data do início do ensaio:</strong> {formatarDataBR(ensaio?.dataMoldagem)}
    &nbsp;&nbsp;&nbsp;
    <strong>Moldagem das barras</strong>
    &nbsp;&nbsp;&nbsp;
    As amostras foram recebidas e identificadas conforme segue:
  </td>
</tr>

    <tr className="cabecalho-amostra">
      <th>Tipo de Material</th>
      <th>Cód. Material</th>
      <th>Data do Recebimento</th>
      <th>Procedência/Fornecedor</th>
      <th>Local da Coleta/Jazida</th>
      <th>Coletado por</th>
    </tr>
    
        {materiaisAmostra.map((m, i) => (

              <tr key={i}>

              <td>{m.tipo}</td>

              <td>{gerarRegistro(m.codigo)}</td>

              <td>{formatarDataFirestore(m.data)}</td>

              <td>{m.fornecedor || "-"}</td>

              <td>{m.localColeta  || "-"}</td>

              <td>{m.codigo !== "-" ? "Entregue pelo Cliente" : "-"}</td>

              </tr>

              ))}

  </tbody>
</table>

{/* ================= SEÇÃO 5 ================= */}
<div className="titulo-secao">
   5. COMPOSIÇÃO DA DOSAGEM DA ARGAMASSA.
</div>        
{/* ================= SEÇÃO 5 - COMPOSIÇÃO ================= */}

<table className="tabela-composicao">
  <tbody>

    <tr>
      <td colSpan="3" className="info-amostra">
        As tabelas a seguir apresentam a composição dos materiais utilizados
        para a preparação de três barras de argamassa:
      </td>
    </tr>

    <tr>

      {/* ESQUERDA */}
      <td className="coluna-esquerda">

        <table className="subtabela">
          <colgroup>
            <col style={{ width: "70%" }} />
            <col style={{ width: "30%" }} />
          </colgroup>
          <thead>
            <tr>
              <th colSpan="2">Cimento Obra</th>
            </tr>
            <tr>
              <th>Propriedades</th>
              <th>Resultados</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Óxido de Sódio Na2O (%)</td><td>N/I</td></tr>
            <tr><td>Óxido de Potássio K2O (%)</td><td>N/I</td></tr>
            <tr><td>Equivalente Alcalino em Na2O (%)</td><td>N/I</td></tr>
            <tr><td>Área Específica Blaine (cm²/g)</td><td>N/I</td></tr>
            <tr><td>Expansibilidade em Autoclave (%)</td><td>N/I</td></tr>
            
              {ensaio?.usarFraseAgregadoGraudo && (
  <tr>
    <td colSpan="2" className="obs-cimento">
      Material triturado em nosso laboratório utilizando dispositivo adequado.
    </td>
  </tr>
)}
           
          </tbody>
        </table>

      </td>

      {/* CENTRO */}
      <td className="coluna-centro">

        <table className="subtabela">
          <thead>
            <tr>
              <th colSpan="4">Composição do traço</th>
            </tr>
            
       
              <tr>
  <th colSpan="2">Abertura nominal das peneiras (mm)</th>
  <th>%</th>
  <th>Massa (g)</th>
</tr>
          </thead>
          <tbody>

            <tr>
              <td rowSpan="5" className="vertical-label">
                Agregado
              </td>
              <td>4,8 - 2,4</td><td>10</td><td>99,0</td>
            </tr>
            <tr><td>2,4 - 1,2</td><td>25</td><td>247,5</td></tr>
            <tr><td>1,2 - 0,6</td><td>25</td><td>247,5</td></tr>
            <tr><td>0,6 - 0,3</td><td>25</td><td>247,5</td></tr>
            <tr><td>0,3 - 0,15</td><td>15</td><td>148,5</td></tr>

            <tr>
              <td colSpan="2">Aglomerante (Cimento)</td>
              <td>-</td>
              <td>
                    {massaCimento.toFixed(1).replace(".", ",")}
                  </td>
            </tr>

            <tr>
                  <td colSpan="2">Adição</td>

                  <td>
                    {percentualAdicao > 0
                      ? `${percentualAdicao.toFixed(0)}%`
                      : "-"}
                  </td>

                  <td>
                    {percentualAdicao > 0
                      ? massaAdicao.toFixed(1).replace(".", ",")
                      : "-"}
                  </td>
                </tr>
            <tr>
              <td colSpan="2">Água destilada</td>
              <td>a/c 0,47</td>
              <td>206,8</td>
            </tr>

          </tbody>
        </table>

      </td>

      {/* DIREITA */}
      <td className="coluna-direita">

        <table className="subtabela">
          <thead>
            <tr>
              <th colSpan="2">Informações Complementares (Rastreabilidade)</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Dosagem Código</td><td> -</td></tr>
            <tr><td>Data (Moldagem)</td><td>{formatarDataBR(ensaio?.dataMoldagem)}</td></tr>
            <tr>
              <td>Temperatura °C</td>
              <td>{ensaio?.temperaturaInicial || "-"}</td>
            </tr>
         
            <tr><td>Código do ensaio</td><td>CE-RE-RAA-{ensaio?.codigo}</td></tr>
        
                      <tr>
                        <td colSpan="2" className="obs-cimento">
                          Obs.: Massa Específica do agregado &gt; 2,45 g/cm³
                        </td>
                      </tr>
          </tbody>
        </table>

      </td>

    </tr>

  </tbody>
</table>
  
{/* ================= SEÇÃO 6 ================= */}

<div className="titulo-secao">
  6. RESULTADOS OBTIDOS.
</div>

<div className="secao-texto">
  Neste item é apresentada a tabela e o gráfico correspondente ao ensaio realizado,
  contendo a evolução da expansão média percentual das barras de argamassa
  obtida nas idades avaliadas:
</div>

<table className="tabela-resultados-horizontal">
  <tbody>

    <tr>
          <th className="coluna-fixa">Idade/Data</th>

          {leiturasProcessadas.map((l, i) => (
            <th key={i} className="idade-data">
              {l.dia} {formatarDataBR(l.dataLeitura)}
            </th>
          ))}
          
        </tr>

    <tr>
          <td className="coluna-fixa">Variação (%)</td>

          {leiturasProcessadas.map((l, i) => (
            <td key={i}>
             {l.expansao !== null
              ? l.expansao.toFixed(2).replace(".", ",")
              : "-"}
            </td>
          ))}
        </tr>

  </tbody>
</table>



{/* ================= SEÇÃO 7 ================= */}

<div style={{ height: "5px" }} />

<div className="grafico-titulo">
  Figura 1: Evolução da Expansão por Reatividade (RAA) - Método Acelerado -
  NBR 15577/18 Parte 5 com o tempo de cura em solução alcalina.
</div>

<div className="grafico-container">
  <LineChart
    width={700}
    height={100}
    data={dadosGrafico}
    margin={{ top: 5, right: 10, left: 15, bottom: 5 }}
  >

    <ReferenceArea y1={0} y2={0.19} fill="#a8b8cc" />
    <ReferenceArea y1={0.19} y2="yMax" fill="#e3c19f" />

    <ReferenceLine y={0.19} stroke="red" strokeWidth={3} />

    <XAxis
          dataKey="dia"
          type="number"
          domain={[1, ultimoDia]}
          ticks={Array.from({ length: ultimoDia }, (_, i) => i + 1)}
          tick={{ fontSize: 9 }}
        >
          <Label
              value=""
              position="insideBottom"
              offset={-2}   // 🔥 deixa bem colado nos números
              style={{
                textAnchor: "middle",
                fontSize: 11
              }}
            />
        </XAxis>

    <YAxis
        domain={[0, ymax]}
        tickCount={6}
        width={65}
        tickFormatter={(v) => v.toFixed(2).replace(".", ",")}
      >
     
        <Label
        value={"Expansão (%)"}
        angle={-90}
        position="center"
        dx={-15}
        style={{
          textAnchor: "middle",   // 🔥 CENTRALIZA (evita sumir)
          fontSize: 11,
          fill: "#313131",
          whiteSpace: "pre-line"
        }}
      />
    </YAxis>

    {/* linha contínua interpolada */}
      <Line
        type="monotone"
        dataKey="expansao"
        data={dadosGrafico}
        stroke="#6a1b9a"
        strokeWidth={2}
        dot={false}
        isAnimationActive={false}
      />

        {/* pontos reais das leituras */}
        <Line
          type="linear"
          dataKey="expansao"
          data={dadosGrafico}
          stroke="transparent"
          dot={{ r: 3, fill: "#1976d2" }}
          isAnimationActive={false}
        />

        </LineChart>
    
        
          <div className="linha-eixo-legenda">

          <div className="legenda-grafico">

            <div className="legenda-item">
              <span className="linha-vermelha"></span>
              Limite NBR 15577 (&gt;0,19%)
            </div>

            <div className="legenda-item">
              <span className="linha-mitigado"></span>
              Mitigação Comprovada
            </div>

            <div className="legenda-item">
  <span className="linha-laranja"></span>
  <strong style={{ color: "#0f3057" }}>
    {" "}Mitigação Não Comprovada
  </strong>
</div>

  </div>

    </div>

 </div>    

{/* ================= SEÇÃO 7 ================= */}

<div className="titulo-secao">
  7. ANÁLISE DOS RESULTADOS.
</div>

<div className="secao-texto">

{leituraFinalValida ? (

  <>
    <div>
      De acordo com os resultados apresentados, observa-se que a amostra
      analisada apresentou {leituraFinal.expansao.toFixed(2).replace(".", ",")}
      % aos 30 dias (29 dias de cura em solução alcalina) indicando
      <strong style={{ color: "#0f3057" }}>
            {" "}{classificacao}
          </strong>
    </div>

    <div style={{ marginTop: "4px" }}>
  Classificação da reatividade potencial do agregado:{" "}
  <strong style={{ color: "#0f3057" }}>
    {classificarReatividade(leituraFinal.expansao)}
  </strong>
</div>
  </>

) : (

  <>
    Data prevista para término do ensaio:{" "}
    <strong>{formatarDataBR(ensaio?.dataPrevistaTermino)}</strong>
  </>

)}

</div>

<div className="observacao-relatorio">

Os resultados de ensaio(s) e as considerações feitas neste relatório
têm significado restrito às amostras analisadas e às condições em
que os ensaios foram executados.

</div>

<div className="rodape-relatorio">
<div className="assinatura-linha">
  <div className="local-data">
{formatarDataExtenso(dataHojeISO())} - Palmas - TO

</div>

  <div className="responsavel">
  <div
    style={{
      width: "220px",
      margin: "0 auto",
      textAlign: "center"
    }}
  >
    <img
      src="/Images/assinaturaLeal.png"
      alt="Assinatura"
      style={{
        height: "35px",
        objectFit: "contain",
        display: "block",
        margin: "0 auto -12px auto"
      }}
    />

    <div style={{ borderTop: "1px solid #000", margin: "2px 0" }} />

    <strong>José Carlos Lemes Leal</strong><br/>
    Eng. Civil CREA 203379/D-TO
  </div>
</div>
</div>

{/* 🔥 AGORA FORA */}
<div className="restrito-documento">

  

  <div className="restrito-documento1">
    DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA
  </div>

</div>
</div> 

</div>
</div> 

</div> 
  
  );
}
